/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Search_Results_DescriptionInputs */

const en_no_search_results_description = /** @type {(inputs: No_Search_Results_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find any results for your search. Try different keywords or contact us.`)
};

const nl_no_search_results_description = /** @type {(inputs: No_Search_Results_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We konden geen resultaten vinden voor uw zoekopdracht. Probeer andere trefwoorden of neem contact op.`)
};

/**
* | output |
* | --- |
* | "We couldn't find any results for your search. Try different keywords or contact us." |
*
* @param {No_Search_Results_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_search_results_description = /** @type {((inputs?: No_Search_Results_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Search_Results_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_no_search_results_description(inputs)
	return en_no_search_results_description(inputs)
});